import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCategoryMultimodal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.9105 2.65707C11.3884 1.80751 12.6116 1.8075 13.0895 2.65707L16.7346 9.13721C17.2033 9.97046 16.6011 11 15.6451 11H8.35494C7.3989 11 6.79676 9.97046 7.26547 9.13721L10.9105 2.65707ZM12 3.77983L8.7824 9.50003H15.2176L12 3.77983Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.25 14.75C2.25 13.7835 3.0335 13 4 13H9C9.9665 13 10.75 13.7835 10.75 14.75V19.75C10.75 20.7165 9.9665 21.5 9 21.5H4C3.0335 21.5 2.25 20.7165 2.25 19.75V14.75ZM4 14.5C3.86193 14.5 3.75 14.6119 3.75 14.75V19.75C3.75 19.8881 3.86193 20 4 20H9C9.13807 20 9.25 19.8881 9.25 19.75V14.75C9.25 14.6119 9.13807 14.5 9 14.5H4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.5 12.5C14.8766 12.5 12.75 14.6266 12.75 17.25C12.75 19.8734 14.8766 22 17.5 22C20.1234 22 22.25 19.8734 22.25 17.25C22.25 14.6266 20.1234 12.5 17.5 12.5ZM14.25 17.25C14.25 15.4551 15.7051 14 17.5 14C19.2949 14 20.75 15.4551 20.75 17.25C20.75 19.0449 19.2949 20.5 17.5 20.5C15.7051 20.5 14.25 19.0449 14.25 17.25Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconCategoryMultimodal as ReactComponent };
